<template>
  <div class="payment-edit">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>ご契約情報</span>
          </li>
        </ul>
      </div>
      <!-- <h1 class="title">個人設定</h1> -->
    </div>
    <div>
      <div class="section">
        <div class="container">
          <div>
            <h2>ご登録中のカード情報</h2>
            <dl class="columns">
              <dt>カード情報</dt>
              <dd>{{ contract.cardInfo }}</dd>
            </dl>
            <dl class="columns">
              <dt>有効期限</dt>
              <dd>{{ contract.exp }}</dd>
            </dl>
            <dl class="columns">
              <dt>次回決済予定日</dt>
              <dd>{{ contract.nextDatetime }}</dd>
            </dl>
            <div
              id="message-area"
              class="error-message mdi mdi-alert-circle-outline"
              v-if="errorMessage"
            >
              {{ errorMessage }}
            </div>
            <div
              id="message-area"
              class="information-message mdi mdi-check-circle-outline"
              v-if="message"
            >
              {{ message }}
            </div>
            <div class="card-area " :class="{ 
              complete: cardInput}">
              <div ref="payjpArea"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import { PAYMENT } from "@/constants/constants";
import Contract from "@/mixins/contract";

export default {
  data() {
    return {
      cardInput: false,
      errorMessage: null,
      message: null,
      contract: {
        cardInfo: null,
        exp: null,
        nextDatetime: null,
      }
    };
  },

  mixins: [Loader, Contract],
  components: {},
  created() {},
  async mounted() {
    this.$emit("hideMap");
    this.cardInput = false;
    await this.showCardInfo();
  },

  beforeDestroy() {
    this.destoryPayjp();
  },

  methods: {
    ...mapActions(["showAccount", "showAccountID", "showUserId", "showCard", "updateCard"]),
    ...mapGetters(["getAccountID"]),

    appendPayJpScriptTag() {
      const attrs = {
        "data-payjp-key": PAYMENT.KEY,
        id: "payjp-script",
        src: "https://checkout.pay.jp/",
        class: "payjp-button",
        "data-payjp-text": "カード情報を変更する",
        "data-payjp-submit-text": "カード情報を変更する",
        "data-payjp-lang": "ja",
        "data-payjp-token-name":"payjp-token",
        "data-payjp-three-d-secure":"true",
        "data-payjp-three-d-secure-workflow":"iframe",
        "data-payjp-extra-attribute-email":"",
        "data-payjp-extra-attribute-phone":"",
        "data-payjp-extra-attribute-phone-code":"JP",
        "data-payjp-partial":"true",
        "data-payjp-on-created":"onTokenCreated",
        "data-payjp-on-failed":"onTokenFailed",
      };
      this.scriptEl = document.createElement("script");
      for (let key in attrs) {
        this.scriptEl.setAttribute(key, attrs[key]);
      }
      this.$refs.payjpArea.appendChild(this.scriptEl);
    },
    onTokenCreated() {
      this.loading(async () => {
        let token = document.getElementsByName("payjp-token")[0].value;
        this.errorMessage = null;
        this.message = null;
        this.cardInput = true;
        try {
          const ret = await this.updateCard({ token: token });
          // 同じカードの場合
          if (ret.data.status === 203) {
            this.errorMessage =
              "すでに登録されているカードと同じです。変更するカード情報を再確認してください。";
          }
          else {
            // 申込後のカード情報取得
            const cardInfo = await this.showCard();
            this.contract.cardInfo = this.parseCardInfo(cardInfo);
            this.contract.exp = this.parseExp(cardInfo);
            this.contract.nextDatetime = cardInfo.subscription_next;

            this.message = "カード情報の変更が完了いたしました。";
          }
        } catch (err) {
          this.errorMessage =
            "カード情報の変更ができませんでした。";
          return;
        }

        // 更新後のアカウント情報
        await this.showAccount(await this.showAccountID());
      });
    },
    onTokenFailed(res) {  // eslint-disable-line no-unused-vars
      // 処理
      this.message = null;
      this.errorMessage =
        "カード情報の変更ができませんでした。再度カード情報の入力を行なってください。";
    },

    async showCardInfo() {
      const aid = await this.showAccountID();
      const uid = await this.showUserId();
      const accountInfo = await this.showAccount(aid);
      if (accountInfo.root_users && accountInfo.root_users.length > 0) {
        const isRootUser = accountInfo.root_users[0] === uid;
        if (isRootUser) {
          const isFreePlan = this.isAccountFree(accountInfo);
          if (!isFreePlan) {
            const cardInfo = await this.showCard();
            this.contract.cardInfo = this.parseCardInfo(cardInfo);
            this.contract.exp = this.parseExp(cardInfo);
            this.contract.nextDatetime = cardInfo.subscription_next;

            this.appendPayJpScriptTag();
            window.onTokenCreated = this.onTokenCreated;
            window.onTokenFailed = this.onTokenFailed;
          }
        }
      }
    },

    destoryPayjp() {
      const payjpCheckoutIframeEl = document.getElementById(
        "payjp-checkout-iframe"
      );
      payjpCheckoutIframeEl.parentElement.remove();
      this.$refs.payjpArea.removeChild(this.scriptEl);
      window.PayjpCheckout = null;
      window.onTokenCreated = null;
      window.onTokenFailed = null;
    },

    parseCardInfo(cardInfo){
      var ret;
      if (cardInfo && cardInfo.last4) {
        ret = cardInfo.brand + " **** **** **** " + cardInfo.last4;
      }
      return ret;
    },
    parseExp(cardInfo){
      var ret;
      if (cardInfo && cardInfo.last4) {
        const month = ( '00' + cardInfo.exp_month ).slice( -2 );
        ret = month + "/" + cardInfo.exp_year;
      }
      return ret;
    }
  },
};
</script>

<style lang="scss">
.payment-edit {
  height: 100vh;

  // .header {
  //   padding-top: 2rem;
  // }
  .section {
    overflow: auto;
    width: 60%;
    max-width: 500px;
    height: calc(100% - 130px);
    position: relative;
    margin: auto;

    .container {
      margin: 2rem;

      h2 {
        text-align: center;
        font-weight: 400;
      }

      .main-area {
        text-align: center;
        font-size: 1.5rem;

        .price-large {
          font-size: 3rem;
          margin: 1rem;
        }
        .price-normal {
          font-weight: 700;
          margin: 0.5rem;
        }
      }

      .sub-area {
        margin-top: 1rem;

        .agree-area {
          margin: auto;
          width: fit-content;
        }

        ul {
          width: fit-content;
          margin: auto;
          list-style-type: none;
        }

        a {
          margin: 0.5rem;
        }
      }
      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: white;
      }
      .columns dd:nth-of-type(odd) {
        background: white;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }
    }
  }
  .card-area {
    text-align: center;
    margin: 2rem;
  }
  .card-area.complete {
    display: none;
  }
  #payjp_checkout_box input[type="button"] {
    font-size: 16px;
  }
  #message-area {
    margin-top: 2rem;
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .right-box {
      right: 0;
      bottom: 0;
      width: 70px;
    }
    .center-box {
      display: inline;
      text-align: center;
      width: calc(100% - 140px);
    }
    .left-box {
      left: 0;
      bottom: 0;
      width: 70px;
    }

    .btn {
      display: inline-block;
      background: white;
      font-size: 14px;
      text-align: center;
      width: 130px;
      height: 30px;
      border-radius: 15px;
      color: var(--purple);
      padding: 6px 20px;
      margin: 10px auto 10px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
        pointer-events: none;
      }
      &.btn-submit {
        background: var(--purple);
        color: #fff;
        margin-left: 3px;
        margin-right: 3px;
      }
      &.btn-cancel {
        background: var(--purple-tertiary);
        color: #000;
        margin-left: 3px;
        margin-right: 3px;
      }
    }

    .text {
      right: 0;
      bottom: 0;
      display: block;
      font-size: 14px;
      padding: 3px 0px;
      margin: 10px 0;
      text-align: center;
      color: var(--purple);
      border-bottom: solid 4px transparent;
      opacity: 0.5;
      pointer-events: none;
    }
    .text.active {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 1;
      cursor: pointer;
      pointer-events: inherit;
    }
    .text.disabled {
      border-bottom: solid 4px var(--purple-secondary);
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
    .text::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_delete.svg") no-repeat center left;
      background-size: 20px 20px;
      padding: 0 0 0 5px;
    }
  }

  .ex-card-area-disable {
    opacity: 0.5;
    pointer-events: none;
    cursor: none;
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_contract.svg") no-repeat center
      center;
  }
}
</style>
